<template>
  <p :class="wrapperClass ? wrapperClass : 'a-input-wrapper-column'">
    <label
      v-if="label"
      :for="$attrs.name"
    >
      {{ label }}
    </label>

    <span
      :class="inputError ? 'a-select-primary a-select-primary-danger' : 'a-select-primary'">
      <select
        v-bind="$attrs"
        v-model="selected"
        :ref="reference"
      >
        <option
          selected
          value=""
        >
        </option>
        <option
          v-for="element in elements"
          :key="element[keyField]"
          :value="element[keyField]"
          :selected="element[keyField] === value ? true : false"
        >
          {{ element[textField] }}
        </option>
      </select>
      <span class="arrow">
        <i class="far fa-chevron-down"></i>
      </span>
    </span>
    <small
      v-if="inputError"
      class="text-color-danger"
    >
      {{ messageError }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'AtomSelectPrimaryTimeout',
  inheritAttrs: false,

  props: {
    elements: Array,
    inputError: Boolean,
    keyField: String,
    label: String,
    messageError: String,
    inputClass: String,
    reference: String,
    textField: String,
    value: [String, Number],
    wrapperClass: String
  },

  watch: {
    selected (newValue) {
      let c = this
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
      this.timeout = setTimeout(function () {
        c.$emit('input', newValue)
      }, 500)
    }
  },

  mounted () {
    this.selected = this.value
  },

  data () {
    return {
      timeout: null,
      selected: null
    }
  }
}
</script>
